import request, { IWorkspaceResponse } from '/@/api/http/request'
import { CameraType, CameraMode } from '/@/types/live-stream'
import { GimbalResetMode } from '/@/types/drone-control'
// import { ELocalStorageKey } from '/@/types'

const API_PREFIX = '/control/api/v1'
// const workspaceId: string = localStorage.getItem(ELocalStorageKey.WorkspaceId) || '

export interface PostPayloadAuthBody {
  payload_index: string
}

// 获取负载控制权
export async function postPayloadAuth (sn: string, body: PostPayloadAuthBody): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(`${API_PREFIX}/devices/${sn}/authority/payload`, body)
  return resp.data
}

// TODO: 画面拖动控制
export enum PayloadCommandsEnum {
  CameraModeSwitch = 'camera_mode_switch',
  CameraPhotoTake = 'camera_photo_take',
  CameraRecordingStart = 'camera_recording_start',
  CameraRecordingStop = 'camera_recording_stop',
  CameraFocalLengthSet = 'camera_focal_length_set',
  GimbalReset = 'gimbal_reset',
  CameraAim = 'camera_aim',
  IrMeteringModeSet = 'ir_metering_mode_set',
  IrMeteringPointSet = 'ir_metering_point_set',
  IrMeteringAreaSet = 'ir_metering_area_set',
}

export enum IrMeteringMode {
  DISABLE = 0,
  SPOT = 1,
  AREA = 2,
}

export interface PostCameraModeBody {
  payload_index: string
  camera_mode: CameraMode
}

export interface PostCameraPhotoBody {
  payload_index: string
}

export interface PostCameraRecordingBody {
  payload_index: string
}

export interface DeleteCameraRecordingParams {
  payload_index: string
}

export interface PostCameraFocalLengthBody {
  payload_index: string,
  camera_type: CameraType,
  zoom_factor: number
}

export interface PostGimbalResetBody{
  payload_index: string,
  reset_mode: GimbalResetMode,
}

export interface PostCameraAimBody{
  payload_index: string,
  camera_type: CameraType,
  locked: boolean,
  x: number,
  y: number,
}

export interface PostIrMeteringModeBody {
  payload_index: string,
  mode: IrMeteringMode,
}

export interface PostIrMeteringPointBody {
  payload_index: string,
  x: number,
  y: number,
}

export interface PostIrMeteringAreaBody {
  payload_index: string,
  x: number,
  y: number,
  width: number,
  height: number,
}

export type PostPayloadCommandsBody = {
  cmd: PayloadCommandsEnum.CameraModeSwitch,
  data: PostCameraModeBody
} | {
  cmd: PayloadCommandsEnum.CameraPhotoTake,
  data: PostCameraPhotoBody
} | {
  cmd: PayloadCommandsEnum.CameraRecordingStart,
  data: PostCameraRecordingBody
} | {
  cmd: PayloadCommandsEnum.CameraRecordingStop,
  data: DeleteCameraRecordingParams
} | {
  cmd: PayloadCommandsEnum.CameraFocalLengthSet,
  data: PostCameraFocalLengthBody
} | {
  cmd: PayloadCommandsEnum.GimbalReset,
  data: PostGimbalResetBody
} | {
  cmd: PayloadCommandsEnum.CameraAim,
  data: PostCameraAimBody
} | {
  cmd: PayloadCommandsEnum.IrMeteringModeSet,
  data: PostIrMeteringModeBody
} | {
  cmd: PayloadCommandsEnum.IrMeteringPointSet,
  data: PostIrMeteringPointBody
} | {
  cmd: PayloadCommandsEnum.IrMeteringAreaSet,
  data: PostIrMeteringAreaBody
}

// 发送负载名称
export async function postPayloadCommands (sn: string, body: PostPayloadCommandsBody): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(`${API_PREFIX}/devices/${sn}/payload/commands`, body)
  return resp.data
}

export enum ThermalPaletteStyle {
  WHITE_HOT = 0,
  BLACK_HOT = 1,
  RED_HOT = 2,
  GREEN_HOT = 3,
  FUSION = 4,
  RAINBOW = 5,
  IRONBOW1 = 6,
  IRONBOW2 = 7,
  ICE_FIRE = 8,
  SEPIA = 9,
  GLOWBOW = 10,
  COLOR1 = 11,
  COLOR2 = 12,
  RAIN = 13,
  HOT_SPOT = 14,
  RAINBOW2 = 15,
  GRAY = 16,
  METAL = 17,
  COLD_SPOT = 18,
}

export enum ThermalGainMode {
  AUTOMATIC = 0,
  LOW = 1,
  HIGH = 2,
}

export enum SwitchAction {
  DISABLE = 0,
  ENABLE = 1,
}

export type PutThermalPropertyBody = {
  payload_index: string,
  property: 'thermal_current_palette_style',
  value: ThermalPaletteStyle,
} | {
  payload_index: string,
  property: 'thermal_gain_mode',
  value: ThermalGainMode,
} | {
  payload_index: string,
  property: 'thermal_isotherm_state',
  value: SwitchAction,
} | {
  payload_index: string,
  property: 'thermal_isotherm_upper_limit',
  value: number,
} | {
  payload_index: string,
  property: 'thermal_isotherm_lower_limit',
  value: number,
}

// 设置热成像属性（调色板/增益/等温线）
export async function putThermalProperty (sn: string, body: PutThermalPropertyBody): Promise<IWorkspaceResponse<null>> {
  const resp = await request.put(`${API_PREFIX}/devices/${sn}/thermal/property`, body)
  return resp.data
}
